import { Heading, Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import { Icon } from '@campgladiator/cgui-core.atoms.icon'
import {
  joinWithCommasAndLastAnd,
  toTitleCase,
} from '../../../../common/utility/strings'
import { TrainerInfoProps } from '../../TrainerBio.d'
import styles from './TrainerInfo.module.scss'

const formatLanguages = (names: string[]) =>
  names.map((name) => {
    const splitName = name.split('_')
    return splitName.map((word) => toTitleCase(word)).join(' ')
  })

const TrainerInfo = ({
  firstName = '',
  lastName = '',
  location = '',
  languages = [],
  rating = 0,
  ratingsNumber = 0,
  trainerSince = '',
  isMobile,
  ...props
}: TrainerInfoProps) => {
  const hasLocation = !!location
  const hasLanguages = languages.length > 0
  const hasRatings = !!rating && !!ratingsNumber
  const hasDateStarted = !!trainerSince

  const nameToDisplay = `${firstName} ${lastName}`.trim()
  const yearStarted = hasDateStarted && new Date(trainerSince).getFullYear()
  const expandedLanguageNames =
    (hasLanguages && formatLanguages(languages)) || []

  return (
    <div className={styles.wrapper} {...props}>
      <Heading className={styles.hiText} type={isMobile ? 'h2' : 'h3'}>
        {`Hi, I'm ${nameToDisplay}!`}
      </Heading>
      <div className={styles.infos}>
        {hasLocation && (
          <span className={styles.info}>
            <Icon name="icon-map-marker-solid" className={styles.icon} />
            <Paragraph size={isMobile ? 'xsmall' : 'small'} weight="book">
              {location}
            </Paragraph>
          </span>
        )}
        {hasLanguages && (
          <span className={styles.info}>
            <Icon name="icon-comments-alt-solid" className={styles.icon} />
            <Paragraph size={isMobile ? 'xsmall' : 'small'} weight="book">
              {`Speaks ${joinWithCommasAndLastAnd(expandedLanguageNames)}`}
            </Paragraph>
          </span>
        )}
        {hasRatings && (
          <span className={styles.info}>
            <Icon name="icon-star-solid" className={styles.icon} />
            <Paragraph size={isMobile ? 'xsmall' : 'small'}>{rating}</Paragraph>
            <Paragraph
              className={styles.ratingsNumber}
              size={isMobile ? 'xsmall' : 'small'}
              weight="book"
            >
              {`(${ratingsNumber})`}
            </Paragraph>
          </span>
        )}
      </div>
      {hasDateStarted && (
        <Paragraph className={styles.trainerSince} weight="book">
          {`CG Trainer Since ${yearStarted}`}
        </Paragraph>
      )}
    </div>
  )
}

export default TrainerInfo
